<mat-chip-set>
  <mat-chip elderChipLabel [levelColor]="levelColor">{{ name }}</mat-chip>
</mat-chip-set>
